/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {PLATFORM_IDS} from '@ion/core/src/utils/DeviceUtils';
import {GridResult} from '@ion/dls/src/grid/PaginationControls';
import JobIdLinks from './JobIdLinks';

export interface PendingEdgeHostedCellType {
  data: GridResult;
}

export const PendingEdgeHostedCell = ({data}: PendingEdgeHostedCellType) => {
  const filterPlatformIds = data?.fileHistoryPending?.filter((item) =>
    item.platformId === PLATFORM_IDS.hostedAppFirmware ||
    item.platformId === PLATFORM_IDS.hostedAppConfig ||
    item.platformId === PLATFORM_IDS.hostedAppV2Firmware ||
    item.platformId === PLATFORM_IDS.hostedAppApnList ||
    item.platformId === PLATFORM_IDS.hostedAppFirmwareFirstPeripheral ||
    item.platformId === PLATFORM_IDS.hostedAppConfigFirstPeripheral ||
    item.platformId === PLATFORM_IDS.hostedAppFirmware2ndPeripheral ||
    item.platformId === PLATFORM_IDS.hostedAppConfig2ndPeripheral ||
    item.platformId === PLATFORM_IDS.hostedAppV3Firmware ||
    item.platformId === PLATFORM_IDS.hostedAppV4Firmware ||
    item.platformId === PLATFORM_IDS.hostedAppV5Firmware ||
    item.platformId === PLATFORM_IDS.hostedAppV6Firmware ||
    item.platformId === PLATFORM_IDS.edgeAppFirmware
  );
  return <JobIdLinks data={filterPlatformIds?.[0]} pendingJobIds={filterPlatformIds} isPendingHostedApp/>;
};
  
export default PendingEdgeHostedCell;
